import React, { useMemo, useContext } from 'react';
import PopularProducts from '.';
import { useRecommendedProducts } from '../../utils/hooks';
import useElevarEvent from '../../hooks/useElevarEvent';
import { convertToElevarDataItem } from '../../utils';
import { AuthContext } from '../../context/auth-context';

function RecommendedProducts({
  title = 'Recommended Products',
  productId,
  location,
  onRecommendedProductsLoaded,
}) {
  const [recommendationsLoading, recommendedProducts] = useRecommendedProducts([productId]);

	const { state: authState } = useContext(AuthContext);
  const { userProperties } = authState;

  const initialProductListAmount = 4;

  const initialProducts = useMemo(
    () => recommendedProducts.slice(0, initialProductListAmount),
    [recommendedProducts, initialProductListAmount]
  );

  const initialVisibleProducts = initialProducts.map((product, index) => convertToElevarDataItem({ item: product, index, location }));

  onRecommendedProductsLoaded({
    recommendedProducts,
    initialVisibleProducts,
    productLength: initialProductListAmount,
  });

	useElevarEvent({
		location,
		productLength: initialVisibleProducts.length,
		eventType: 'dl_view_item_list',
		allImpressions: initialVisibleProducts,
		impressions: initialProducts,
		userProperties,
	});

  return (
    <PopularProducts
      location={location}
      title={title}
      collection={{ products: recommendedProducts }}
      isLoading={recommendationsLoading}
    />
  );
}

export default RecommendedProducts;
